import { useEffect, useState } from "react";
export type MobilePlatform = "android" | "ios" | "other";

export function getMobilePlatform(): MobilePlatform {
  if (typeof window === "undefined" || typeof navigator === "undefined") return "other";

  const uaData: any = (navigator as any).userAgentData;
  const ch = uaData?.platform?.toLowerCase?.();
  if (ch) {
    if (ch.includes("ios")) return "ios";
    if (ch.includes("android")) return "android";
  }

  const ua = navigator.userAgent || (navigator as any).vendor || "";
  const platform = (navigator as any).platform || "";

  const isIOS =
    /(iPad|iPhone|iPod)/i.test(ua) ||
    /(iPad|iPhone|iPod)/i.test(platform) ||
    (platform === "MacIntel" && (navigator as any).maxTouchPoints > 1);

  if (isIOS) return "ios";
  if (/\bandroid\b/i.test(ua)) return "android";
  return "other";
}


export function useMobilePlatform() {
  const [platform, setPlatform] = useState<MobilePlatform>("other");
  useEffect(() => {
    setPlatform(getMobilePlatform()); // runs after mount on client
  }, []);
  return platform;
}
